module.exports = __webpack_public_path__ + "media/34_BL.84ceb1c1.mp3";